<template lang="pug">
.content-wrap
	topbar
	.content-top
		.con
			highlight
			rtt
			.cat-tab.nbswi
				.swiper.glcat-swiper.nbswi-swiper
					.swiper-wrapper
						.swiper-slide
							.cat(@click="$router.push('/')")
								img(src='/new/img/tab/c-hot.png')
								| hot
						.swiper-slide
							.cat.aaa
								img(src='/new/img/tab/c-slot.png')
								| slots
						.swiper-slide
							.cat(@click="$router.push('/casino')")
								img(src='/new/img/tab/c-casino.png')
								| live
						.swiper-slide
							.cat(@click="$router.push('/table')")
								img(src='/new/img/tab/c-poker.png')
								| poker
						.swiper-slide
							.cat(@click="$router.push('/bingo')")
								img(src='/new/img/tab/c-bingo.png')
								| bingo
						.swiper-slide
							.cat(@click="$router.push('/hash')")
								img(src='/new/img/tab/c-hash.png')
								| hash
						template(v-if="isLoggedIn")
							.swiper-slide
								router-link.cat(to="/launchWbet" target="_blank")
									img(src='/new/img/tab/c-sport.png')
									| sports
						template(v-else)
							.swiper-slide
								a.cat(@click="$helpers.openModal('#logModal')")
									img(src='/new/img/tab/c-sport.png')
									| sports
						.swiper-slide
							.cat(@click="$router.push('/fishing')")
								img(src='/new/img/tab/c-fish.png')
								| fishing
				.swiper-button-prev.glcat-swiper-prev
				.swiper-button-next.glcat-swiper-next
			.searchbar
				.fav.pointer(v-if="isLoggedIn" @click="toggleFav")
					i.fa-heart(:class="{'fa-solid fav-red': showFav, 'fa-regular': !showFav}")
				.fav.pointer(v-if="!isLoggedIn" @click="$helpers.openModal('#logModal')")
					i.fa-regular.fa-heart
				input.form-control(type='text' v-model="searchinput" placeholder='Search')
				.s-icon
					i.fa-solid.fa-magnifying-glass
			.glmenu.nbswi.mt-2
				.swiper.glpro-swiper.nbswi-swiper
					.swiper-wrapper
						.swiper-slide(@click="changeProvider(1)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 1 }")
								img(src='/new/img/provider/jili.png')
						.swiper-slide(@click="changeProvider(8)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 8 }")
								img(src='/new/img/provider/epicwin.png')
						.swiper-slide(@click="changeProvider(0)")
							.g-pro.pro(:class="{'aaa c-filter' : providerSelected === 0,  'c-filter1': providerSelected !== 0}")
								img(src='/new/img/provider/pgsoft.png' )
						.swiper-slide(@click="changeProvider(3)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 3 }")
								img(src='/new/img/provider/fc-gaming.png')
						.swiper-slide(@click="changeProvider(16)")
							.g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 16,  'c-filter2': providerSelected !== 16}")
								img(src='/new/img/bprovider/hacksaw.png')
						.swiper-slide(@click="changeProvider(10)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 10 }")
								img(src='/new/img/provider/cq9.png')
						.swiper-slide(@click="changeProvider(5)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 5 }")
								img(src='/new/img/provider/jdb.png')
						.swiper-slide(@click="changeProvider(11)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 11 }")
								img(src='/new/img/provider/pragmatic.png')
						.swiper-slide(@click="changeProvider(23)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 23 }")
								img(src='/new/img/provider/BNG.png')
						.swiper-slide(@click="changeProvider(6)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 6 }")
								img(:class="{'inactive-f' : providerSelected !== 6 }" src='/new/img/provider/live22.png')
						.swiper-slide(@click="changeProvider(22)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 22, 'gray-s': providerSelected != 22 }")
								img(:class="{'inactive-f' : providerSelected !== 22 }" src='/new/img/bprovider/nlc.png')
						.swiper-slide(@click="changeProvider(27)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 27 }")
								img(src='/new/img/provider/ygr.png')
						.swiper-slide(@click="changeProvider(4)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 4 }")
								img(src='/new/img/provider/yes-bingo.png')
						.swiper-slide(@click="changeProvider(7)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 7 }")
								img(src='/new/img/provider/yl-gaming.png')
						.swiper-slide(@click="changeProvider(14)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 14 }")
								img(src='/new/img/provider/SpadeGaming.png')
						.swiper-slide(@click="changeProvider(12)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 12 }")
								img(src='/new/img/provider/microgaming.png')
						.swiper-slide(@click="changeProvider(13)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 13 }")
								img(src='/new/img/provider/spinix.png')
						.swiper-slide(@click="changeProvider(2)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 2 }")
								img(src='/new/img/provider/fastspin.png')
						//- .swiper-slide(@click="changeProvider(15)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 15 }")
								img(src='/new/img/provider/bgaming.png')
								| Bgaming
						.swiper-slide(@click="changeProvider(17)")
							.g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 17,  'c-filter2': providerSelected !== 17}")
								img(src='/new/img/provider/relax-gaming.png')
						.swiper-slide(@click="changeProvider(18)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 18 }")
								img(:class="{'inactive-f' : providerSelected !== 18 }" src='/new/img/bprovider/evoplay.png')
						.swiper-slide(@click="changeProvider(19)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 19 }")
								img(src='/new/img/provider/playngo.png')
						.swiper-slide(@click="changeProvider(20)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 20 }")
								img(src='/new/img/bprovider/netent.png')
						.swiper-slide(@click="changeProvider(21)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 21 }")
								img(:class="{'inactive-f' : providerSelected !== 21 }" src='/new/img/bprovider/redtiger.png')
						.swiper-slide(@click="changeProvider(24)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 24 }")
								img(src='/new/img/bprovider/advantplay.png')
						.swiper-slide(@click="changeProvider(25)")
							.g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 25,  'c-filter2': providerSelected !== 25}")
								img(src='/new/img/provider/alize.png')
						//- .swiper-slide(@click="changeProvider(23)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 23 }")
								img(src='/new/img/provider/spb.png')
								| SPB
						//- .swiper-slide(@click="changeProvider(9)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 9 }")
								img(src='/new/img/provider/habanero.png')
								| Habanero
						//- .swiper-slide(@click="changeProvider(26)")
							.g-pro.pro(:class="{'aaa' : providerSelected === 26 }")
								img(src='/new/img/provider/wow.png')
								| Wow Gaming
				.swiper-button-prev.glpro-swiper-prev
				.swiper-button-next.glpro-swiper-next
			favList(v-if="showFav" :searchinput="searchinput")
			live22(v-if="providerSelected === 6 && !showFav" :searchinput="searchinput")
			pg(v-if="providerSelected === 0 && !showFav" :searchinput="searchinput")
			jili(v-if="providerSelected === 1 && !showFav" :searchinput="searchinput")
			fastspin(v-if="providerSelected === 2 && !showFav" :searchinput="searchinput")
			fc(v-if="providerSelected === 3 && !showFav" :searchinput="searchinput")
			yesbingo(v-if="providerSelected === 4 && !showFav" :searchinput="searchinput")
			jdb(v-if="providerSelected === 5 && !showFav" :searchinput="searchinput")
			yl(v-if="providerSelected === 7 && !showFav" :searchinput="searchinput")
			cq9(v-if="providerSelected === 10 && !showFav" :searchinput="searchinput")
			//- habanero(v-if="providerSelected === 9 && !showFav" :searchinput="searchinput")
			epic(v-if="providerSelected === 8 && !showFav" :searchinput="searchinput")
			pragmatic(v-if="providerSelected === 11 && !showFav" :searchinput="searchinput")
			microgaming(v-if="providerSelected === 12 && !showFav" :searchinput="searchinput")
			spinix(v-if="providerSelected === 13 && !showFav" :searchinput="searchinput")
			spadegaming(v-if="providerSelected === 14 && !showFav" :searchinput="searchinput")
			//- bgaming(v-if="providerSelected === 15 && !showFav" :searchinput="searchinput")
			hacksaw(v-if="providerSelected === 16 && !showFav" :searchinput="searchinput")
			relaxgaming(v-if="providerSelected === 17 && !showFav" :searchinput="searchinput")
			evoplay(v-if="providerSelected === 18 && !showFav" :searchinput="searchinput")
			playngo(v-if="providerSelected === 19 && !showFav" :searchinput="searchinput")
			netent(v-if="providerSelected === 20 && !showFav" :searchinput="searchinput")
			evort(v-if="providerSelected === 21 && !showFav" :searchinput="searchinput")
			nlc(v-if="providerSelected === 22 && !showFav" :searchinput="searchinput")
			bng(v-if="providerSelected === 23 && !showFav" :searchinput="searchinput")
			advantplay(v-if="providerSelected === 24 && !showFav" :searchinput="searchinput")
			alize(v-if="providerSelected === 25 && !showFav" :searchinput="searchinput")
			//- spb(v-if="providerSelected === 26 && !showFav" :searchinput="searchinput")
			ygr(v-if="providerSelected === 27 && !showFav" :searchinput="searchinput")
			//- wow(v-if="providerSelected === 26 && !showFav" :searchinput="searchinput")
			//- social
			footerInfo(:target="'/slot'")
</template>
<script>
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import highlight from '@/component/_highlight.vue'
import rtt from '@/component/_realTimeTrans.vue'
import favList from '@/component/slot/_favList.vue'
import live22 from '@/component/slot/_live22.vue'
import pg from '@/component/slot/_pg.vue'
// import jili from '@/component/slot/launchopen/_jili.vue'
import jili from '@/component/slot/_jili.vue'
import fc from '@/component/slot/_fc.vue'
import fastspin from '@/component/slot/_fastSpin.vue'
import yesbingo from '@/component/slot/_yesBingo.vue'
import jdb from '@/component/slot/_jdb.vue'
import yl from '@/component/egame/_yl.vue'
import cq9 from '@/component/slot/_cq9.vue'
// import habanero from '@/component/slot/_habanero.vue'
import epic from '@/component/slot/_epicGame.vue'
import pragmatic from '@/component/slot/launchone/_pragmatic.vue'
// import pragmatic from '@/component/slot/_pragmatic.vue'
import microgaming from '@/component/slot/launchone/_microGaming.vue'
import spinix from '@/component/slot/launchone/_spinix.vue'
import spadegaming from '@/component/slot/launchone/_spadeGaming.vue'
// import bgaming from '@/component/slot/launchone/_bGaming.vue'
import hacksaw from '@/component/slot/launchone/_hacksaw.vue'
import relaxgaming from '@/component/slot/launchone/_relaxGaming.vue'
import evoplay from '@/component/slot/launchone/_evoplay.vue'
import playngo from '@/component/slot/launchone/_playngo.vue'
import netent from '@/component/slot/launchone/_netent.vue'
import evort from '@/component/slot/launchone/_rt.vue'
import nlc from '@/component/slot/launchone/_nlc.vue'
import bng from '@/component/slot/launchone/_bng.vue'
import advantplay from '@/component/slot/launchone/_advantPlay.vue'
import alize from '@/component/slot/launchone/_alize.vue'
import ygr from '@/component/slot/_ygr.vue'
// import wow from '@/component/slot/_wow.vue'
// import spb from '@/component/slot/launchone/_spb.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
import social from '@/component/_social.vue'
export default {
	components:{
		topbar,
    highlight,
    rtt,
    footerInfo,
    social,
		favList,
		live22,
		pg,
		jili,
		fastspin,
		fc,
		yesbingo,
		jdb,
		yl,
		cq9,
		// habanero,
		epic,
		pragmatic,
		microgaming,
		spinix,
		spadegaming,
		// bgaming,
		hacksaw,
		relaxgaming,
		evoplay,
		playngo,
		netent,
		evort,
		nlc,
		bng,
		advantplay,
		alize,
		ygr,
		// wow,
		// spb,
	},
	data(){
		return{
			feedback: {
				success: true,
				status: ""
			},
			loading:false,
			showMobile: false,
			providerSelected: 1,
			imgUrl: config.imageUrl,
			showSearch: false,
			providerList:[
				"PGSOFT",
				"JILI",
				"FASTSPIN",
				"FACHAI",
				"YESBINGO",
				"JDB",
				"LIVE22",
				"YLGAMING",
				"EpicWin",
				"HABANERO",
				"CQ9",
				"PRAGMATIC",
				"MICROGAMING",
				"SPINIX",
				"SPADEGAMING",
				"BGAMING",
				"HACKSAW",
				"RELAXGAMING",
				"EVOPLAY",
				"PLAY'NGO",
				"NETENT",
				"REDTIGER",
				"NLC",
				"BNG",
				"ADVANTPLAY",
				"ALIZE",
				"WOWGAMING",
				"YGR"
				// "SPRIBE",
			],
			searchinput:"",
			showFav: false,
      currentPath: ""
		}
	},
	computed: {
		isLoggedIn(){
			return this.$store.getters.isLoggedIn
		},
		accountID() {
			return this.$store.getters.accountID
		},
		sessionToken() {
			return this.$store.getters.sessionToken
		},
		getProvider(){
			return this.providerList[this.providerSelected]
		},
	},
	watch:{
    $route (to, from){
      this.currentPath = to.path
    }
	},	
	created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/slot`);
		this.getSeo("slot")
		// this.checkSize()
		// var vm = this
		// $(window).resize(function () {
		// 	vm.checkSize()
		// });
	},
	mounted(){
		this.currentPath = this.$router.currentRoute.path
		if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.custom == true){
				this.providerSelected = 8
			}
			if(this.$route.params.target){
				this.providerSelected = Number(this.$route.params.target)
			}
    }
		if ($('.glcat-swiper').length) {
			const gboxSwiper = new Swiper('.glcat-swiper', {
				slidesPerView: 6.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glcat-swiper-next',
					prevEl: '.glcat-swiper-prev'
				},
				watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: {
						slidesPerView: 6.5
					},
					960: {
						slidesPerView: 8
					}
				}
			})
    }
		if ($('.glpro-swiper').length) {
        const gboxSwiper = new Swiper('.glpro-swiper', {
					slidesPerView: 3.5,
					spaceBetween: 4,
					navigation: {
							nextEl: '.glpro-swiper-next',
							prevEl: '.glpro-swiper-prev'
					},
					watchOverflow: true,
					autoplay:false,
					breakpoints: {
							768: {
									slidesPerView: 6.5
							},
							960: {
									slidesPerView: 6.5
							}
					}
			})
		}
	},
	methods:{
		openModal(){
			$("#logModal").modal('show')
		},
		toggleFav(){
			this.showFav = !this.showFav
		},
		toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},
		getSeo(page){
			let page_name = page
			this.$store
				.dispatch("user/getSeo", {page_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
		changeProvider(option){
			if(option !== this.providerSelected){
				this.providerSelected = option
			}
			this.showFav = false
			// if(option === this.providerSelected){
			// 	return
			// }else{
			// 	this.providerSelected = option
			// }
		},
		checkSize(){
			if ($(window).width() < 681) {
				this.showMobile = true
			}else{
				this.showMobile = false
			}
		},
	}
}
</script>
<style lang="scss" scoped>
.iicon{
	@media(min-width: 681px) {
		position: inherit;
		max-width: 100% !important;
	}
	
}
.gbox-search .iicon{
	@media(min-width: 681px) {
		width: 30px;
		height: inherit;
	}
	
}

</style>
